import i18n from "@/i18n"

//TODO 移除

// 首页字段配置信息
//let home_english = {
//  nav: {
//    login: {name: 'login', url: ''},
//    register: {name: 'register', url: ''},
//    menu: {name: "menu", url: ''},
//    navigation: [{name: 'productsCenter', url: ''}, {name: 'solution', url: ''}, {
//      name: 'customerCase',
//      url: ''
//    }, {name: 'docs', url: ''}, {name: 'aboutUs', url: ''}]
//  },
//  contactUs: {
//    contact: 'contact us',
//    telephone: '021-52180789',
//    // qq:'26807376',
//    sms: 'service@hotdb.com',
//    adress: 'No. 25 Pioneer Street, Minhang District, Shanghai 9c',
//    // phone:'138 1798 4195',
//    sheet: ""
//  }
//}

let home = () => ({
  nav: {
    login: {name: i18n.t('m02'), url: ''},
    register: {name: i18n.t('m03'), url: ''}
  },
  opearNav: {
    username: {name: i18n.t('m18'), url: ''},
    logout: {name: i18n.t('m19'), url: ''}
  },
  navigation: [{name: i18n.t( 'c01'), url: '/server'}, {
    name: i18n.t( 'a01'),
    url: '/docs'
  }, {name: i18n.t( 'x08'), url: '/customer'}, {
    name: i18n.t( 'm21'),
    url: '/download'
  }, {name: i18n.t( 'm01'), url: '/aboutUs'}],
  contactUs: [
    {
      cname: 'icon-zuoji',
      text: '021-52180789'
    },
    // {
    //     cname:'icon-iconfontqq',
    //     text:'26807376'
    // },
    {
      cname: 'icon-icon1',
      text: 'service@hotdb.com'
    },
    {
      cname: 'icon-dingwei',
      text: i18n.t( '074')
    },
    // {
    //     cname:'icon-tongxunlu',
    //     text:'138 1798 4195'
    // },
    {
      cname: 'icon-iconfonticonfontxinxi',
      text: ''
    },
  ]
})

export default {
  home: home,
}



// WEBPACK FOOTER //
// ./src/config/index.js